export const USER_ACCOUNT_CONFIG = {
    ACTIVE: {
        label: "Active",
        color: "#065F46", bg: "#ECFDF5", border: "#A7F3D0", dot: "#10B981",
        iconName: "solar:user-check-rounded-bold",
        pulse: true,
    },
    INACTIVE: {
        label: "Inactive",
        color: "#374151", bg: "#F9FAFB", border: "#E5E7EB", dot: "#9CA3AF",
        iconName: "solar:user-minus-rounded-bold",
    },
    SUSPENDED: {
        label: "Suspended",
        color: "#92400E", bg: "#FFFBEB", border: "#FDE68A", dot: "#F59E0B",
        iconName: "solar:user-block-rounded-bold",
    },
    BANNED: {
        label: "Banned",
        color: "#991B1B", bg: "#FFF1F2", border: "#FECDD3", dot: "#F43F5E",
        iconName: "solar:forbidden-circle-bold",
    },
    INVITED: {
        label: "Invited",
        color: "#1E40AF", bg: "#EFF6FF", border: "#BFDBFE", dot: "#3B82F6",
        iconName: "solar:letter-bold",
    },
}